import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { collectionsQuery } from 'networking/mindfeed/queries/collections';
import { useActiveSpace } from 'xstate/hooks/useActiveSpace';
import type { Collection } from 'models/Collection';
import { BoxId } from 'models/Box';

type QueryKeyType = [QueryKey.COLLECTIONS, BoxId?];

type Options = Omit<
  UseQueryOptions<Collection[], unknown, Collection[], QueryKeyType>,
  'queryKey' | 'queryFn'
>;

type Params = {
  options?: Options;
};

export default function useCollections({ options = {} }: Params = {}) {
  const { selectedBoxId } = useActiveSpace();

  // Same definition as the space machine uses, so a list it already loaded
  // is read from the cache here. With no box selected the query is defined
  // but doesn't run (see collectionsQuery).
  const query = useQuery({
    ...collectionsQuery(selectedBoxId),
    // Keep previous data while new data is being fetched
    // This prevents unnecessary loading states and improves UX
    placeholderData: (previousData) => previousData,
    ...options,
  });

  return {
    ...query,
    isLoading: !selectedBoxId || query.isPending,
  };
}
